// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__9dgfY {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 18px 0px;
  margin: 0 auto;
  height: calc(100% - 60px);
  min-height: 68.5vh;
}

.styles_title__ZR2Iu {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #696969;
}

.styles_text__ZQmct {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
  padding: 1em 0;
}

.styles_wrapper__Kf9Sl {
  border-radius: unset;
}

.styles_inputStyle__rSoJQ {
  width: 353px !important;
  height: 100%;
}

.styles_sendButton__yjYLq {
  border-radius: 5px;
  width: 100%;
  height: auto;
  color: #fff;
  margin: 0 !important;
  border: unset !important;
  margin-bottom: 15px !important;
  margin-top: auto;
}

.styles_inputError__F1jRj {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_serverError__Asz9M {
  background: #ff9315;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  height: auto;
  padding: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.styles_serverError__Asz9M span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px;
}

.styles_inputStyle__rSoJQ {
  width: 420px !important;
  height: 100%;
}

.styles_wrapperInputStyle__jWAlS,
.styles_inputStyle__rSoJQ {
  width: 100% !important;
}

.styles_inputTitleStyle__l8uU5 {
  font-style: normal;
  font-weight: Bold;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
  margin-bottom: 8px;
}

@media only screen and (max-width: 1024px) {
  .styles_inputStyle__rSoJQ {
    width: 353px !important;
  }
}
@media only screen and (max-width: 800px) {
  .styles_newSize__epdcw {
    height: 32px !important;
    font-size: 12px !important;
  }
  .styles_container__9dgfY {
    padding: 20px 0;
  }
  .styles_wrapperInputStyle__jWAlS,
  .styles_inputStyle__rSoJQ {
    width: 100% !important;
  }
  .styles_title__ZR2Iu {
    display: none;
  }
  .styles_inputStyle__rSoJQ {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ChangePassword/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EAIE,oBAAA;AAFF;;AAMA;EACE,uBAAA;EAEA,YAAA;AAJF;;AAOA;EACE,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,wBAAA;EACA,8BAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AALF;;AAQA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AALF;;AAQA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALF;;AAQA;EACE,uBAAA;EAEA,YAAA;AANF;;AASA;;EAEE,sBAAA;AANF;;AAUA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAPF;;AAUA;EACE;IACE,uBAAA;EAPF;AACF;AAWA;EACE;IACE,uBAAA;IACA,0BAAA;EATF;EAaA;IACE,eAAA;EAXF;EAcA;;IAEE,sBAAA;EAZF;EAeA;IACE,aAAA;EAbF;EAgBA;IACE,sBAAA;EAdF;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 18px 0px;\n  margin: 0 auto;\n  height: calc(100% - 60px);\n  min-height: 68.5vh;\n}\n\n.title {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  color: #696969;\n}\n\n.text {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n  padding: 1em 0;\n}\n\n.wrapper {\n  // border: unset;\n  // border:unset !important;\n  // border-bottom: 1px solid rgba(0, 0, 0, 0.50) !important;\n  border-radius: unset;\n  // margin-top:50px;\n}\n\n.inputStyle {\n  width: 353px !important;\n  // height: 44px;\n  height: 100%;\n}\n\n.sendButton {\n  border-radius: 5px;\n  // background: #075B52;\n  width: 100%;\n  height: auto;\n  color: #fff;\n  margin: 0 !important;\n  border: unset !important;\n  margin-bottom: 15px !important;\n  margin-top: auto;\n}\n\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n}\n\n.serverError {\n  background: #ff9315;\n  border-radius: 4px;\n  color: #ffffff;\n  width: 100%;\n  height: auto;\n  padding: 0.5em;\n  margin-bottom: 1em;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.serverError span {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  padding: 0 2px;\n}\n\n.inputStyle {\n  width: 420px !important;\n  // height: 44px;\n  height: 100%;\n}\n\n.wrapperInputStyle,\n.inputStyle {\n  width: 100% !important;\n}\n\n\n.inputTitleStyle {\n  font-style: normal;\n  font-weight: Bold;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n  margin-bottom: 8px;\n}\n\n@media only screen and (max-width: 1024px) {\n  .inputStyle {\n    width: 353px !important;\n    // height: 44px;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  .newSize {\n    height: 32px !important;\n    font-size: 12px !important;\n\n  }\n\n  .container {\n    padding: 20px 0;\n  }\n\n  .wrapperInputStyle,\n  .inputStyle {\n    width: 100% !important;\n  }\n\n  .title {\n    display: none;\n  }\n\n  .inputStyle {\n    width: 100% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__9dgfY`,
	"title": `styles_title__ZR2Iu`,
	"text": `styles_text__ZQmct`,
	"wrapper": `styles_wrapper__Kf9Sl`,
	"inputStyle": `styles_inputStyle__rSoJQ`,
	"sendButton": `styles_sendButton__yjYLq`,
	"inputError": `styles_inputError__F1jRj`,
	"serverError": `styles_serverError__Asz9M`,
	"wrapperInputStyle": `styles_wrapperInputStyle__jWAlS`,
	"inputTitleStyle": `styles_inputTitleStyle__l8uU5`,
	"newSize": `styles_newSize__epdcw`
};
export default ___CSS_LOADER_EXPORT___;
